// Cable Configurator — Woodstock 3.2.0
(function () {
  'use strict';

  const CONNECTOR_CATEGORIES = [
    { id: 'usb', label: 'USB', connectors: [
      { id: 'usb-a',       label: 'USB-A',          svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="9" width="26" height="12" rx="2" stroke="currentColor" stroke-width="1.4"/><rect x="30" y="12" width="7" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/><rect x="8" y="12.5" width="18" height="5" rx="1" stroke="currentColor" stroke-width="0.8" stroke-dasharray="2 1.5" opacity="0.5"/></svg>` },
      { id: 'usb-c',       label: 'USB-C',           svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="10" width="26" height="10" rx="5" stroke="currentColor" stroke-width="1.4"/><rect x="30" y="12" width="7" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/><line x1="10" y1="15" x2="26" y2="15" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'micro-usb',   label: 'Micro USB',       svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><polygon points="4,11 30,8 30,22 4,19" stroke="currentColor" stroke-width="1.4" fill="none"/><rect x="30" y="12" width="7" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/></svg>` },
      { id: 'micro-usb3',  label: 'Micro USB 3.0',   svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><polygon points="4,12 18,9 18,21 4,18" stroke="currentColor" stroke-width="1.3" fill="none"/><rect x="18" y="10" width="12" height="10" rx="1" stroke="currentColor" stroke-width="1.3"/><rect x="30" y="12" width="7" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/></svg>` },
      { id: 'mini-usb',    label: 'Mini USB',         svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><polygon points="4,10 30,8 30,22 4,20" stroke="currentColor" stroke-width="1.4" fill="none"/><rect x="30" y="12" width="7" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/></svg>` },
      { id: 'usb-b',       label: 'USB-B',            svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><polygon points="6,8 30,8 34,12 34,22 6,22" stroke="currentColor" stroke-width="1.4" fill="none"/><rect x="11" y="13" width="16" height="7" rx="1" stroke="currentColor" stroke-width="0.9" opacity="0.5"/></svg>` },
    ]},
    { id: 'video', label: 'Video & Display', connectors: [
      { id: 'hdmi',        label: 'HDMI',             svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><polygon points="2,7 34,7 34,22 2,22" stroke="currentColor" stroke-width="1.4" fill="none"/><line x1="2" y1="22" x2="5" y2="26" stroke="currentColor" stroke-width="1.2"/><line x1="34" y1="22" x2="31" y2="26" stroke="currentColor" stroke-width="1.2"/><line x1="5" y1="26" x2="31" y2="26" stroke="currentColor" stroke-width="1.2"/><rect x="6" y="10" width="22" height="8" rx="1" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'displayport', label: 'DisplayPort',       svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><polygon points="2,8 28,8 34,15 28,22 2,22" stroke="currentColor" stroke-width="1.4" fill="none"/><rect x="6" y="11.5" width="18" height="7" rx="1" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'thunderbolt', label: 'Thunderbolt',       svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="10" width="26" height="10" rx="5" stroke="currentColor" stroke-width="1.4"/><rect x="30" y="12" width="7" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/><polygon points="18,12 24,12 19,16 23,16 15,22 19,17 15,17" stroke="currentColor" stroke-width="0.7" fill="none" opacity="0.7"/></svg>` },
      { id: 'dvi',         label: 'DVI',               svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="2" y="7" width="36" height="16" rx="2" stroke="currentColor" stroke-width="1.4"/><circle cx="10" cy="11" r="1.2" stroke="currentColor" stroke-width="1"/><circle cx="16" cy="11" r="1.2" stroke="currentColor" stroke-width="1"/><circle cx="22" cy="11" r="1.2" stroke="currentColor" stroke-width="1"/><circle cx="10" cy="16" r="1.2" stroke="currentColor" stroke-width="1"/><circle cx="16" cy="16" r="1.2" stroke="currentColor" stroke-width="1"/><circle cx="22" cy="16" r="1.2" stroke="currentColor" stroke-width="1"/><rect x="27" y="10" width="5" height="10" rx="1" stroke="currentColor" stroke-width="1"/></svg>` },
      { id: 'vga',         label: 'VGA / DB15',        svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="2" y="8" width="38" height="14" rx="2" stroke="currentColor" stroke-width="1.4"/><circle cx="10" cy="12" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="18" cy="12" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="26" cy="12" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="14" cy="17" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="22" cy="17" r="1.3" stroke="currentColor" stroke-width="1"/></svg>` },
      { id: 'toslink',     label: 'Toslink / Optisch', svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="8" y="8" width="18" height="14" rx="3" stroke="currentColor" stroke-width="1.4"/><circle cx="17" cy="15" r="4" stroke="currentColor" stroke-width="1.2"/><circle cx="17" cy="15" r="1.5" stroke="currentColor" stroke-width="1"/><line x1="26" y1="15" x2="36" y2="15" stroke="currentColor" stroke-width="1.5" stroke-dasharray="2 2"/></svg>` },
      { id: 'scart',       label: 'SCART',             svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="2" y="6" width="36" height="18" rx="2" stroke="currentColor" stroke-width="1.4"/><line x1="6" y1="10" x2="6" y2="20" stroke="currentColor" stroke-width="1" opacity="0.5"/><line x1="10" y1="10" x2="10" y2="20" stroke="currentColor" stroke-width="1" opacity="0.5"/><line x1="14" y1="10" x2="14" y2="20" stroke="currentColor" stroke-width="1" opacity="0.5"/><line x1="18" y1="10" x2="18" y2="20" stroke="currentColor" stroke-width="1" opacity="0.5"/><line x1="22" y1="10" x2="22" y2="20" stroke="currentColor" stroke-width="1" opacity="0.5"/><line x1="26" y1="10" x2="26" y2="20" stroke="currentColor" stroke-width="1" opacity="0.5"/><line x1="30" y1="10" x2="30" y2="20" stroke="currentColor" stroke-width="1" opacity="0.5"/></svg>` },
    ]},
    { id: 'audio', label: 'Audio', connectors: [
      { id: '3.5mm',       label: '3,5-mm-Klinke',    svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><line x1="4" y1="15" x2="32" y2="15" stroke="currentColor" stroke-width="3.5" stroke-linecap="round"/><circle cx="36" cy="15" r="5" stroke="currentColor" stroke-width="1.4" fill="none"/><line x1="10" y1="15" x2="10" y2="15" stroke="currentColor" stroke-width="6" stroke-linecap="round" opacity="0.35"/><line x1="20" y1="15" x2="20" y2="15" stroke="currentColor" stroke-width="6" stroke-linecap="round" opacity="0.35"/></svg>` },
      { id: 'xlr',         label: 'XLR',              svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><circle cx="20" cy="15" r="11" stroke="currentColor" stroke-width="1.4"/><circle cx="20" cy="10" r="1.8" stroke="currentColor" stroke-width="1.1"/><circle cx="15" cy="18" r="1.8" stroke="currentColor" stroke-width="1.1"/><circle cx="25" cy="18" r="1.8" stroke="currentColor" stroke-width="1.1"/><line x1="31" y1="15" x2="40" y2="15" stroke="currentColor" stroke-width="1.5"/></svg>` },
      { id: 'rca',         label: 'RCA / Cinch',      svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><circle cx="18" cy="15" r="9" stroke="currentColor" stroke-width="1.4"/><circle cx="18" cy="15" r="3.5" stroke="currentColor" stroke-width="1.2"/><line x1="27" y1="15" x2="38" y2="15" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>` },
      { id: 'bnc',         label: 'BNC',              svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><circle cx="18" cy="15" r="9" stroke="currentColor" stroke-width="1.4"/><circle cx="18" cy="15" r="2.5" fill="currentColor" opacity="0.4"/><line x1="18" y1="6" x2="18" y2="4" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><line x1="18" y1="24" x2="18" y2="26" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><line x1="27" y1="15" x2="38" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>` },
    ]},
    { id: 'network', label: 'Netzwerk & Daten', connectors: [
      { id: 'ethernet',    label: 'Ethernet / RJ45',  svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="12" y="6" width="20" height="18" rx="1.5" stroke="currentColor" stroke-width="1.4"/><rect x="15" y="18" width="14" height="5" rx="1" stroke="currentColor" stroke-width="0.9"/><line x1="16" y1="9" x2="16" y2="15" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><line x1="20" y1="9" x2="20" y2="15" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><line x1="24" y1="9" x2="24" y2="15" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><line x1="28" y1="9" x2="28" y2="15" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>` },
      { id: 'sata',        label: 'SATA',             svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="11" width="32" height="8" rx="1" stroke="currentColor" stroke-width="1.4"/><line x1="10" y1="11" x2="10" y2="19" stroke="currentColor" stroke-width="0.9" opacity="0.4"/><line x1="16" y1="11" x2="16" y2="19" stroke="currentColor" stroke-width="0.9" opacity="0.4"/><line x1="22" y1="11" x2="22" y2="19" stroke="currentColor" stroke-width="0.9" opacity="0.4"/><line x1="28" y1="11" x2="28" y2="19" stroke="currentColor" stroke-width="0.9" opacity="0.4"/></svg>` },
      { id: 'sff-8087',    label: 'SFF-8087',         svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="2" y="9" width="36" height="12" rx="1" stroke="currentColor" stroke-width="1.4"/><line x1="7" y1="9" x2="7" y2="21" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="13" y1="9" x2="13" y2="21" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="19" y1="9" x2="19" y2="21" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="25" y1="9" x2="25" y2="21" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="31" y1="9" x2="31" y2="21" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'sff-8643',    label: 'SFF-8643',         svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="2" y="9" width="36" height="12" rx="1" stroke="currentColor" stroke-width="1.4"/><rect x="6" y="12" width="6" height="6" rx="0.5" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><rect x="15" y="12" width="6" height="6" rx="0.5" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><rect x="24" y="12" width="6" height="6" rx="0.5" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'sff-8482',    label: 'SFF-8482 / SAS',   svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="8" width="28" height="14" rx="1" stroke="currentColor" stroke-width="1.4"/><rect x="32" y="11" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.1"/><line x1="9" y1="8" x2="9" y2="22" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="16" y1="8" x2="16" y2="22" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="23" y1="8" x2="23" y2="22" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'm2',          label: 'M.2',              svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="12" width="34" height="6" rx="1" stroke="currentColor" stroke-width="1.4"/><line x1="8" y1="12" x2="8" y2="18" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="13" y1="12" x2="13" y2="18" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="18" y1="12" x2="18" y2="18" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="23" y1="12" x2="23" y2="18" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="28" y1="12" x2="28" y2="18" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="33" y1="12" x2="33" y2="18" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'nvme',        label: 'NVMe / PCIe',      svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="2" y="11" width="38" height="8" rx="1" stroke="currentColor" stroke-width="1.4"/><line x1="7" y1="11" x2="7" y2="19" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="13" y1="11" x2="13" y2="19" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="19" y1="11" x2="19" y2="19" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="25" y1="11" x2="25" y2="19" stroke="currentColor" stroke-width="0.8" opacity="0.4"/><line x1="31" y1="11" x2="31" y2="19" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>` },
      { id: 'oculink',     label: 'OcuLink',          svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="10" width="30" height="10" rx="2" stroke="currentColor" stroke-width="1.4"/><rect x="34" y="12" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/><line x1="9" y1="10" x2="9" y2="20" stroke="currentColor" stroke-width="0.9" opacity="0.4"/><line x1="15" y1="10" x2="15" y2="20" stroke="currentColor" stroke-width="0.9" opacity="0.4"/><line x1="21" y1="10" x2="21" y2="20" stroke="currentColor" stroke-width="0.9" opacity="0.4"/><line x1="27" y1="10" x2="27" y2="20" stroke="currentColor" stroke-width="0.9" opacity="0.4"/></svg>` },
    ]},
    { id: 'serial', label: 'Seriell & Legacy', connectors: [
      { id: 'db9',         label: 'DB9 / RS-232',     svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="8" width="34" height="14" rx="3" stroke="currentColor" stroke-width="1.4"/><circle cx="12" cy="13" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="20" cy="13" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="28" cy="13" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="16" cy="18" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="24" cy="18" r="1.3" stroke="currentColor" stroke-width="1"/></svg>` },
      { id: 'db15',        label: 'DB15',             svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="2" y="8" width="38" height="14" rx="3" stroke="currentColor" stroke-width="1.4"/><circle cx="8" cy="13" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="14" cy="13" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="20" cy="13" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="26" cy="13" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="32" cy="13" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="11" cy="18" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="17" cy="18" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="23" cy="18" r="1.1" stroke="currentColor" stroke-width="1"/><circle cx="29" cy="18" r="1.1" stroke="currentColor" stroke-width="1"/></svg>` },
      { id: 'db25',        label: 'DB25',             svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="1" y="8" width="40" height="14" rx="3" stroke="currentColor" stroke-width="1.4"/><circle cx="6" cy="13" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="11" cy="13" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="16" cy="13" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="21" cy="13" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="26" cy="13" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="31" cy="13" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="36" cy="13" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="8" cy="18" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="14" cy="18" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="20" cy="18" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="26" cy="18" r="1" stroke="currentColor" stroke-width="0.9"/><circle cx="32" cy="18" r="1" stroke="currentColor" stroke-width="0.9"/></svg>` },
      { id: 'ps2',         label: 'PS/2',             svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><circle cx="20" cy="15" r="10" stroke="currentColor" stroke-width="1.4"/><circle cx="20" cy="10" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="25" cy="13" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="25" cy="18" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="20" cy="20" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="15" cy="18" r="1.3" stroke="currentColor" stroke-width="1"/><circle cx="15" cy="13" r="1.3" stroke="currentColor" stroke-width="1"/></svg>` },
    ]},
    { id: 'mobile', label: 'Mobil', connectors: [
      { id: 'lightning',   label: 'Lightning',        svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="4" y="10.5" width="26" height="9" rx="4.5" stroke="currentColor" stroke-width="1.4"/><rect x="30" y="12" width="7" height="6" rx="1" stroke="currentColor" stroke-width="1.1"/><line x1="17" y1="15" x2="19" y2="15" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>` },
      { id: 'apple-watch', label: 'Apple Watch',      svg: `<svg width="44" height="30" viewBox="0 0 44 30" fill="none"><rect x="12" y="6" width="18" height="18" rx="5" stroke="currentColor" stroke-width="1.4"/><circle cx="21" cy="15" r="4" stroke="currentColor" stroke-width="1.1"/><line x1="30" y1="15" x2="38" y2="15" stroke="currentColor" stroke-width="1.5" stroke-dasharray="2 2"/></svg>` },
    ]},
  ];

  const CONNECTORS = CONNECTOR_CATEGORIES.flatMap(cat => cat.connectors);

  const PAIRINGS = {
    'usb-a':       ['usb-c', 'micro-usb', 'micro-usb3', 'mini-usb', 'usb-b', 'lightning'],
    'usb-c':       ['usb-c', 'hdmi', 'lightning', 'displayport', 'thunderbolt', 'vga', 'dvi'],
    'micro-usb':   ['usb-a'],
    'micro-usb3':  ['usb-a'],
    'mini-usb':    ['usb-a'],
    'usb-b':       ['usb-a'],
    'thunderbolt': ['thunderbolt', 'hdmi', 'displayport', 'usb-c'],
    'hdmi':        ['hdmi', 'displayport', 'vga', 'dvi', 'usb-c'],
    'displayport': ['hdmi', 'displayport', 'vga', 'dvi'],
    'dvi':         ['hdmi', 'displayport', 'vga'],
    'vga':         ['hdmi', 'displayport', 'dvi'],
    'toslink':     ['toslink'],
    'ethernet':    ['ethernet'],
    '3.5mm':       ['3.5mm', 'xlr', 'rca', 'usb-c'],
    'xlr':         ['xlr', '3.5mm', 'rca'],
    'rca':         ['rca', '3.5mm', 'xlr'],
    'bnc':         ['bnc'],
    'sata':        ['sff-8087', 'sff-8643', 'sff-8482', 'usb-a', 'usb-c'],
    'sff-8087':    ['sata', 'sff-8482'],
    'sff-8643':    ['sata', 'sff-8482'],
    'sff-8482':    ['sff-8087', 'sff-8643', 'sata'],
    'm2':          ['usb-c', 'nvme'],
    'nvme':        ['m2', 'usb-c', 'oculink'],
    'oculink':     ['nvme', 'usb-c'],
    'db9':         ['usb-a', 'usb-c', 'db9'],
    'db15':        ['db15', 'vga'],
    'db25':        ['db25', 'usb-a'],
    'ps2':         ['usb-a'],
    'lightning':   ['usb-a', 'usb-c'],
    'apple-watch': ['usb-a', 'usb-c'],
    'scart':       ['hdmi', 'vga', 'rca'],
  };

  const CONNECTOR_SPECS = {
    'usb-c': [
      { id: 'protocol', label: 'Standard / Protokoll', options: [
        { id: 'usb2',    label: 'USB 2.0',       desc: '480 Mbit/s' },
        { id: 'usb32g1', label: 'USB 3.2 Gen 1', desc: '5 Gbit/s' },
        { id: 'usb32g2', label: 'USB 3.2 Gen 2', desc: '10 Gbit/s' },
        { id: 'usb4',    label: 'USB4',           desc: '40 Gbit/s' },
        { id: 'tb3',     label: 'Thunderbolt 3',  desc: '40 Gbit/s' },
        { id: 'tb4',     label: 'Thunderbolt 4',  desc: '40 Gbit/s' },
        { id: 'tb5',     label: 'Thunderbolt 5',  desc: '120 Gbit/s' },
      ]},
      { id: 'power', label: 'Power Delivery', options: [
        { id: 'pd18',  label: 'bis 18 W',  desc: '' },
        { id: 'pd60',  label: 'bis 60 W',  desc: '' },
        { id: 'pd100', label: 'bis 100 W', desc: 'E-Marker' },
        { id: 'pd240', label: 'bis 240 W', desc: 'EPR' },
      ]},
      { id: 'video', label: 'Videoausgang', options: [
        { id: 'novideo', label: 'Keiner',      desc: '' },
        { id: 'dp-alt',  label: 'DP Alt Mode', desc: '' },
        { id: '4k60',    label: '4K@60Hz',     desc: '' },
        { id: '8k30',    label: '8K@30Hz',     desc: '' },
      ]},
    ],
    'usb-a': [
      { id: 'protocol', label: 'USB-Generation', options: [
        { id: 'usb2',    label: 'USB 2.0', desc: '480 Mbit/s' },
        { id: 'usb32g1', label: 'USB 3.0', desc: '5 Gbit/s' },
        { id: 'usb32g2', label: 'USB 3.1', desc: '10 Gbit/s' },
      ]},
      { id: 'power', label: 'Ladeleistung', options: [
        { id: 'std',  label: 'Standard 5 W',   desc: '' },
        { id: 'bc12', label: 'BC 1.2',          desc: '7,5 W' },
        { id: 'qc',   label: 'Quick Charge 3.0',desc: '18 W' },
      ]},
    ],
    'thunderbolt': [
      { id: 'version', label: 'Thunderbolt-Version', options: [
        { id: 'tb3', label: 'Thunderbolt 3', desc: '40 Gbit/s' },
        { id: 'tb4', label: 'Thunderbolt 4', desc: '40 Gbit/s' },
        { id: 'tb5', label: 'Thunderbolt 5', desc: '120 Gbit/s' },
      ]},
      { id: 'power', label: 'Power Delivery', options: [
        { id: 'pd60',  label: '60 W',  desc: '' },
        { id: 'pd100', label: '100 W', desc: '' },
        { id: 'pd240', label: '240 W', desc: 'TB5' },
      ]},
    ],
    'hdmi': [
      { id: 'version', label: 'HDMI-Version', options: [
        { id: 'hdmi14', label: 'HDMI 1.4', desc: '4K@30Hz' },
        { id: 'hdmi20', label: 'HDMI 2.0', desc: '4K@60Hz' },
        { id: 'hdmi21', label: 'HDMI 2.1', desc: '8K@60Hz' },
      ]},
      { id: 'features', label: 'Funktionen', options: [
        { id: 'earc', label: 'eARC',         desc: '' },
        { id: 'vrr',  label: 'VRR / G-Sync', desc: '' },
      ]},
    ],
    'displayport': [
      { id: 'version', label: 'DisplayPort-Version', options: [
        { id: 'dp12', label: 'DP 1.2', desc: '4K@60Hz' },
        { id: 'dp14', label: 'DP 1.4', desc: '8K@60Hz' },
        { id: 'dp20', label: 'DP 2.0', desc: '16K' },
      ]},
    ],
    'ethernet': [
      { id: 'speed', label: 'Kategorie', options: [
        { id: 'cat5e', label: 'Cat 5e', desc: '1 Gbit/s' },
        { id: 'cat6',  label: 'Cat 6',  desc: '10 Gbit/s' },
        { id: 'cat7',  label: 'Cat 7',  desc: 'abgeschirmt' },
        { id: 'cat8',  label: 'Cat 8',  desc: '40 Gbit/s' },
      ]},
    ],
    'lightning': [
      { id: 'cert', label: 'Zertifizierung', options: [
        { id: 'mfi',   label: 'MFi zertifiziert',   desc: '' },
        { id: 'nomfi', label: 'Nicht zertifiziert',  desc: '' },
      ]},
    ],
    '3.5mm': [
      { id: 'poles', label: 'Polkonfiguration', options: [
        { id: 'ts',   label: 'TS (Mono)',       desc: '2-polig' },
        { id: 'trs',  label: 'TRS (Stereo)',    desc: '3-polig' },
        { id: 'trrs', label: 'TRRS + Mikrofon', desc: '4-polig' },
      ]},
    ],
  };

  const INFO_ICON = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="5.25" stroke="currentColor" stroke-width="1.1"/><line x1="6" y1="5.5" x2="6" y2="9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="6" cy="3.5" r="0.75" fill="currentColor"/></svg>`;
  const LENGTHS = [0.1, 0.25, 0.3, 0.4, 0.5, 1.0, 1.5, 2.0, 3.0, 5.0];
  const LENGTH_OVER_5 = 99; // Sonderwert für 'länger als 5m'

  let selA = null, selB = null, selLen = null, activeSlot = null;
  let specSelections = {};
  let filterAngled = false;
  let filterAdapter = false; // null=alle, true=nur Adapter, false=nur Kabel
  let filterOverLen = false; // true = länger als 5m

  const $ = id => document.getElementById(id);
  const con = id => CONNECTORS.find(c => c.id === id);
  const fmtLen = l => l < 1 ? (l * 100).toFixed(0) + ' cm' : (l % 1 === 0 ? l + ' m' : l.toFixed(1) + ' m');

  window.ccOpenPopup = function (side) {
    activeSlot = side;
    $('cc-popup-title').textContent = `Stecker wählen — Seite ${side}`;
    $('cc-popup-search').value = '';
    renderPopupGrid('');
    $('cc-overlay').classList.add('cc-overlay--open');
    document.body.classList.add('open-drawer-fixed');
    setTimeout(() => $('cc-popup-search').focus(), 60);
  };

  window.ccClosePopup = function () {
    $('cc-overlay').classList.remove('cc-overlay--open');
    document.body.classList.remove('open-drawer-fixed');
  };

  window.ccCloseBg = function (e) { if (e.target === $('cc-overlay')) ccClosePopup(); };
  window.ccFilterPopup = function () { renderPopupGrid($('cc-popup-search').value.toLowerCase()); };

  function renderPopupGrid(q) {
    const grid = $('cc-popup-grid');
    const cur = activeSlot === 'A' ? selA : selB;
    if (q) {
      const list = CONNECTORS.filter(c => c.label.toLowerCase().includes(q));
      grid.innerHTML = list.length
        ? list.map(c => popupItemHtml(c, cur)).join('')
        : '<div class="cc-no-match">Kein Stecker gefunden</div>';
      return;
    }
    grid.innerHTML = CONNECTOR_CATEGORIES.map(cat => `
      <div class="cc-popup-cat">
        <div class="cc-popup-cat__label">${cat.label}</div>
        <div class="cc-popup-cat__grid">${cat.connectors.map(c => popupItemHtml(c, cur)).join('')}</div>
      </div>`).join('');
  }

  function popupItemHtml(c, cur) {
    return `<button class="cc-popup-item${cur === c.id ? ' cc-popup-item--selected' : ''}"
      onclick="ccSelectConnector('${c.id}')" type="button">
      ${c.svg}<div class="cc-pi-label">${c.label}</div>
    </button>`;
  }

  window.ccSelectConnector = function (id) {
    if (activeSlot === 'A') selA = id; else selB = id;
    specSelections = {};
    fillSlot(activeSlot, id);
    ccClosePopup();
    updateAll();
  };

  function fillSlot(side, id) {
    const c = con(id);
    const btn = $('cc-btn' + side);
    btn.classList.add('cc-slot__btn--filled');
    btn.classList.remove('cc-slot__btn--pulse');
    $('cc-icon-' + side).innerHTML = c.svg.replace('width="44"', 'width="48"').replace('height="30"', 'height="34"');
    $('cc-name-' + side).textContent = c.label;
    $('cc-hint-' + side).textContent = 'Tippen zum Ändern';
  }

  window.ccClearSlot = function (e, side) {
    e.stopPropagation();
    if (side === 'A') selA = null; else selB = null;
    specSelections = {};
    const btn = $('cc-btn' + side);
    btn.classList.remove('cc-slot__btn--filled');
    $('cc-icon-' + side).innerHTML = `<svg width="40" height="30" viewBox="0 0 40 30" fill="none"><circle cx="20" cy="15" r="10" stroke="currentColor" stroke-width="1.5" stroke-dasharray="3 2" opacity="0.35"/><line x1="16" y1="15" x2="24" y2="15" stroke="currentColor" stroke-width="1.5" opacity="0.35"/><line x1="20" y1="11" x2="20" y2="19" stroke="currentColor" stroke-width="1.5" opacity="0.35"/></svg>`;
    $('cc-name-' + side).textContent = 'Stecker wählen';
    $('cc-hint-' + side).textContent = 'Tippen zum Auswählen';
    updateAll();
  };

  const INFO = {
    usb2:    { tag: 'USB', title: 'USB 2.0', body: 'USB 2.0 überträgt Daten mit bis zu <strong>480 Mbit/s</strong>. Ausreichend für Laden und einfachen Datentransfer.', tip: 'Ideal für: Laden, Mäuse, Tastaturen.' },
    usb32g1: { tag: 'USB', title: 'USB 3.2 Gen 1 (5 Gbit/s)', body: 'Überträgt Daten mit bis zu <strong>5 Gbit/s</strong> — ca. 10× schneller als USB 2.0.', tip: 'Erkennbar am blauen USB-A-Port.' },
    usb32g2: { tag: 'USB', title: 'USB 3.2 Gen 2 (10 Gbit/s)', body: 'Verdoppelt die Bandbreite auf <strong>10 Gbit/s</strong>. Ideal für schnelle SSDs.', tip: 'Perfekt für NVMe-Gehäuse.' },
    usb4:    { tag: 'USB', title: 'USB4', body: 'USB4 läuft mit bis zu <strong>40 Gbit/s</strong> und ist elektrisch kompatibel mit Thunderbolt 3.', tip: 'Benötigt einen USB4- oder TB3/TB4-Port.' },
    tb3:     { tag: 'Thunderbolt', title: 'Thunderbolt 3', body: 'TB3 liefert <strong>40 Gbit/s</strong>, unterstützt ein 5K- oder zwei 4K-Displays und bis zu <strong>60 W Laden</strong>.', tip: 'TB3-Passivkabel bis 0,8 m unterstützen 40 Gbit/s.' },
    tb4:     { tag: 'Thunderbolt', title: 'Thunderbolt 4', body: 'TB4 bietet <strong>40 Gbit/s</strong>, unterstützt zwei 4K-Displays und bis zu <strong>100 W Power Delivery</strong>.', tip: 'Ports mit Blitz-Symbol gekennzeichnet.' },
    tb5:     { tag: 'Thunderbolt', title: 'Thunderbolt 5', body: 'Thunderbolt 5 erreicht <strong>120 Gbit/s</strong> und unterstützt <strong>240 W Power Delivery</strong>.', tip: 'Erfordert Intel Core Ultra oder Apple M4.' },
    pd18:    { tag: 'Power', title: 'PD bis 18 W', body: 'Bis zu <strong>18 W</strong> — ausreichend für Schnellladen der meisten Smartphones.', tip: 'Smartphones benötigen mindestens 18 W PD.' },
    pd60:    { tag: 'Power', title: 'PD bis 60 W', body: 'Bis zu <strong>60 W</strong> — genug um die meisten Ultrabooks zu laden.', tip: 'Für mehr als 60 W wird ein E-Marker benötigt.' },
    pd100:   { tag: 'Power', title: 'PD bis 100 W', body: 'Enthält einen <strong>E-Marker-Chip</strong> für 5 A / 100 W. Für 15-Zoll-MacBook-Pros und Gaming-Laptops.', tip: 'Echte 100-W-Kabel listen den E-Marker im Datenblatt.' },
    pd240:   { tag: 'Power', title: 'PD bis 240 W (EPR)', body: 'Extended Power Range aus <strong>USB PD 3.1</strong> — bis zu 48 V × 5 A = <strong>240 W</strong>.', tip: 'EPR-Kabel nicht mit Standard-Kabeln austauschen.' },
    hdmi14:  { tag: 'HDMI', title: 'HDMI 1.4', body: 'Bis zu <strong>4K bei 30 Hz</strong> oder <strong>1080p bei 120 Hz</strong>.', tip: 'Für flüssiges 4K wird HDMI 2.0 benötigt.' },
    hdmi20:  { tag: 'HDMI', title: 'HDMI 2.0', body: 'Standard für <strong>4K bei 60 Hz</strong> mit HDR10 und Dolby Vision.', tip: 'Standard für aktuelle 4K-Displays.' },
    hdmi21:  { tag: 'HDMI', title: 'HDMI 2.1', body: '<strong>48 Gbit/s</strong> für <strong>8K@60Hz</strong>, <strong>4K@120Hz</strong>, VRR und eARC.', tip: 'HDMI-2.1-Kabel sind abwärtskompatibel.' },
    cat5e:   { tag: 'Ethernet', title: 'Cat 5e', body: 'Bis zu <strong>1 Gbit/s bei 100 MHz</strong>. Ausreichend für die meisten Heimnetzwerke.', tip: 'Reicht für Breitband bis 1 Gbit/s.' },
    cat6:    { tag: 'Ethernet', title: 'Cat 6', body: '<strong>10 Gbit/s bis 55 m</strong>. Die Standardwahl für neue Installationen.', tip: 'Bestes Preis-Leistungs-Verhältnis für NAS.' },
    cat7:    { tag: 'Ethernet', title: 'Cat 7', body: '<strong>10 Gbit/s bei 600 MHz</strong> mit vollständig abgeschirmten Paaren.', tip: 'Ideal für EMI-reiche Umgebungen.' },
    cat8:    { tag: 'Ethernet', title: 'Cat 8', body: '<strong>25–40 Gbit/s bei 2000 MHz</strong> über bis zu 30 Meter.', tip: 'Zukunftssicher für Rack- oder NAS-Cluster.' },
    mfi:     { tag: 'Lightning', title: 'MFi-zertifiziert', body: 'Enthält einen <strong>Apple-Authentifizierungschip</strong> — verhindert "Zubehör nicht unterstützt"-Warnungen.', tip: 'Immer MFi für iPhone verwenden.' },
    trrs:    { tag: '3,5 mm', title: 'TRRS', body: 'Vier Leiter für <strong>Stereo + Mikrofon</strong>.', tip: 'Bei Mikrofon-Problemen: OMTP/CTIA-Mismatch prüfen.' },
  };

  window.ccOpenInfo = function (id, e) {
    e.stopPropagation();
    const info = INFO[id]; if (!info) return;
    $('cc-info-title').textContent = info.title;
    $('cc-info-tag').textContent = info.tag;
    $('cc-info-body').innerHTML = info.body;
    const tip = $('cc-info-tip');
    if (info.tip) { tip.textContent = info.tip; tip.style.display = 'block'; }
    else { tip.style.display = 'none'; }
    $('cc-info-overlay').classList.add('cc-overlay--open');
    document.body.classList.add('open-drawer-fixed');
  };

  window.ccCloseInfo = function () {
    $('cc-info-overlay').classList.remove('cc-overlay--open');
    document.body.classList.remove('open-drawer-fixed');
  };

  window.ccCloseInfoBg = function (e) { if (e.target === $('cc-info-overlay')) ccCloseInfo(); };

  function getSpecGroups() {
    const ids = [selA, selB].filter(Boolean);
    const seen = {}, groups = [];
    ids.forEach(id => (CONNECTOR_SPECS[id] || []).forEach(g => {
      if (!seen[g.id]) { seen[g.id] = true; groups.push(g); }
    }));
    return groups;
  }

  function renderSpecs() {
    const panel = $('cc-specs-panel');
    const groups = getSpecGroups();
    const showAngle = selA || selB;
    if (!showAngle && !groups.length) { panel.classList.remove('cc-specs--visible'); return; }

    const names = [...new Set([selA, selB].filter(Boolean).map(id => con(id).label))];
    $('cc-specs-title').textContent = `Spezifikationen${names.length ? ' für ' + names.join(' & ') : ''}`;

    const angleHtml = showAngle ? `
      <div class="cc-spec-group">
        <div class="cc-spec-group__label">Produkttyp</div>
        <div class="cc-radio-row">
          <button class="cc-radio-opt${!filterAdapter ? ' cc-radio-opt--checked' : ''}" onclick="ccSetAdapter(false)" type="button"><span class="cc-radio-dot"></span> Alle</button>
          <button class="cc-radio-opt${filterAdapter === 'cable' ? ' cc-radio-opt--checked' : ''}" onclick="ccSetAdapter('cable')" type="button"><span class="cc-radio-dot"></span> Nur Kabel</button>
          <button class="cc-radio-opt${filterAdapter === 'adapter' ? ' cc-radio-opt--checked' : ''}" onclick="ccSetAdapter('adapter')" type="button"><span class="cc-radio-dot"></span> Nur Adapter</button>
        </div>
      </div>
      <div class="cc-spec-divider"></div>
      <div class="cc-spec-group">
        <div class="cc-spec-group__label">Steckerform</div>
        <div class="cc-radio-row">
          <button class="cc-radio-opt${filterAngled === false ? ' cc-radio-opt--checked' : ''}" onclick="ccSetAngle(false)" type="button"><span class="cc-radio-dot"></span> Alle</button>
          <button class="cc-radio-opt${filterAngled === 'straight' ? ' cc-radio-opt--checked' : ''}" onclick="ccSetAngle('straight')" type="button"><span class="cc-radio-dot"></span> Gerade</button>
          <button class="cc-radio-opt${filterAngled === 'angled' ? ' cc-radio-opt--checked' : ''}" onclick="ccSetAngle('angled')" type="button"><span class="cc-radio-dot"></span> Gewinkelt</button>
        </div>
      </div>` : '';

    $('cc-spec-groups').innerHTML = angleHtml + groups.map((g, gi) => `
      ${gi > 0 || showAngle ? '<div class="cc-spec-divider"></div>' : ''}
      <div class="cc-spec-group">
        <div class="cc-spec-group__label">${g.label}</div>
        <div class="cc-radio-row">
          ${g.options.map(o => `
            <button class="cc-radio-opt${specSelections[g.id] === o.id ? ' cc-radio-opt--checked' : ''}" onclick="ccPickSpec('${g.id}','${o.id}')" type="button">
              <span class="cc-radio-dot"></span>${o.label}
              ${o.desc ? `<span style="font-size:1rem;opacity:0.55;margin-left:0.2rem;">(${o.desc})</span>` : ''}
              ${INFO[o.id] ? `<button class="cc-info-btn" onclick="ccOpenInfo('${o.id}',event)" type="button">${INFO_ICON}</button>` : ''}
            </button>`).join('')}
          ${specSelections[g.id] ? `<button class="cc-spec-clear" onclick="ccClearSpec('${g.id}')" type="button">zurücksetzen</button>` : ''}
        </div>
      </div>`).join('');

    panel.classList.add('cc-specs--visible');
  }

  window.ccSetAngle = function (val) { filterAngled = val; renderSpecs(); renderResults(); };
  window.ccSetAdapter = function (val) { filterAdapter = val; renderSpecs(); renderResults(); };
  window.ccPickSpec = function (gId, oId) {
    if (specSelections[gId] === oId) delete specSelections[gId]; else specSelections[gId] = oId;
    renderSpecs(); renderResults();
  };
  window.ccClearSpec = function (gId) { delete specSelections[gId]; renderSpecs(); renderResults(); };

  function lenChipLabel(l, i) {
    if (l === LENGTH_OVER_5) return 'über 5 m';
    if (i === 0) return `bis ${fmtLen(l)}`;
    return `${fmtLen(LENGTHS[i - 1])}–${fmtLen(l)}`;
  }

  function renderLengths() {
    const allChips = LENGTHS.map((l, i) =>
      `<button class="cc-len-chip${selLen === l ? ' cc-len-chip--active' : ''}" onclick="ccPickLen(${l})" type="button">${lenChipLabel(l, i)}</button>`
    ).join('');
    const overChip = `<button class="cc-len-chip${filterOverLen ? ' cc-len-chip--active' : ''}" onclick="ccToggleOverLen()" type="button">über 5 m</button>`;
    $('cc-len-chips').innerHTML = allChips + overChip;
    const i = LENGTHS.indexOf(selLen);
    if (filterOverLen) $('cc-len-display').textContent = 'über 5 m';
    else $('cc-len-display').textContent = selLen ? lenChipLabel(selLen, i) : 'alle';
  }

  window.ccPickLen = function (l) {
    selLen = selLen === l ? null : l;
    filterOverLen = false;
    renderLengths(); updateSteps(); updateEmptyState(); renderResults();
  };

  window.ccToggleOverLen = function () {
    filterOverLen = !filterOverLen;
    if (filterOverLen) selLen = null;
    renderLengths(); updateSteps(); updateEmptyState(); renderResults();
  };

  // Reset alle Filter
  window.ccResetAll = function () {
    selA = null; selB = null; selLen = null;
    specSelections = {}; filterAngled = false;
    filterAdapter = false; filterOverLen = false;
    // Slots zurücksetzen
    ['A','B'].forEach(side => {
      const btn = $('cc-btn' + side);
      btn.classList.remove('cc-slot__btn--filled');
      $('cc-icon-' + side).innerHTML = `<svg width="40" height="30" viewBox="0 0 40 30" fill="none"><circle cx="20" cy="15" r="10" stroke="currentColor" stroke-width="1.5" stroke-dasharray="3 2" opacity="0.35"/><line x1="16" y1="15" x2="24" y2="15" stroke="currentColor" stroke-width="1.5" opacity="0.35"/><line x1="20" y1="11" x2="20" y2="19" stroke="currentColor" stroke-width="1.5" opacity="0.35"/></svg>`;
      $('cc-name-' + side).textContent = 'Stecker wählen';
      $('cc-hint-' + side).textContent = 'Tippen zum Auswählen';
    });
    updateAll();
  };

  function updateEmptyState() {
    const both = selA && selB;
    const one = (selA && !selB) || (!selA && selB);
    const anyFilter = selA || selB || selLen;

    $('cc-empty').classList.toggle('cc-empty--hidden', !!anyFilter);
    $('cc-partial').classList.toggle('cc-partial--visible', one && !both);
    $('cc-results-bar').classList.add('cc-results-bar--visible');

    if (one && !both) {
      const filledId = selA || selB;
      $('cc-partial-text').innerHTML = `Tipp: Wähle auch Seite <strong>${selA ? 'B' : 'A'}</strong> für genauere Ergebnisse.`;
      const sugs = (PAIRINGS[filledId] || []).slice(0, 5);
      $('cc-partial-suggestions').innerHTML = sugs.map(sid => {
        const c = con(sid);
        return c ? `<button class="cc-sug-btn" onclick="ccQuickPick('${sid}')" type="button">${c.label}</button>` : '';
      }).join('');
    }

    // Reset-Button anzeigen wenn irgendwas ausgewählt ist
    const hasAnyFilter = selA || selB || selLen || filterOverLen || filterAngled !== false || filterAdapter !== false || Object.keys(specSelections).length > 0;
    const resetBar = $('cc-reset-bar');
    if (resetBar) resetBar.classList.toggle('cc-reset-bar--visible', !!hasAnyFilter);

    $('cc-btnA').classList.toggle('cc-slot__btn--pulse', !selA);
    $('cc-btnB').classList.toggle('cc-slot__btn--pulse', selA && !selB);
    $('cc-wire-l').classList.toggle('cc-wire--active', !!selA);
    $('cc-wire-r').classList.toggle('cc-wire--active', !!selB);
  }

  window.ccQuickPick = function (id) { activeSlot = selA ? 'B' : 'A'; ccSelectConnector(id); };
  window.ccApplyExample = function (aId, bId) {
    selA = aId; selB = bId; specSelections = {};
    fillSlot('A', aId); fillSlot('B', bId); updateAll();
  };

  function updateSteps() {
    const states = [
      selA ? 'done' : 'active',
      selA && selB ? 'done' : selA ? 'active' : '',
      selA && selB && selLen ? 'done' : (selA && selB ? 'active' : ''),
      selA && selB ? 'active' : '',
    ];
    [1,2,3,4].forEach((n, i) => {
      const c = $('cc-step'+n+'c'), l = $('cc-step'+n+'l');
      if (c) c.className = 'cc-step__circle' + (states[i] ? ' cc-step__circle--'+states[i] : '');
      if (l) l.className = 'cc-step__label' + (states[i] ? ' cc-step__label--'+states[i] : '');
    });
  }

  function renderResults() {
    const grid = $('cc-results-grid');
    const bar = $('cc-results-bar');
    const products = window.CABLE_PRODUCTS || [];
    const activeTags = Object.values(specSelections).filter(Boolean);

    const filtered = products.filter(p => {
      const lMatch = (() => {
        if (filterOverLen) return (p.lengths || []).some(l => l > 5) || (p.lengths || []).length === 0;
        if (!selLen) return true;
        const i = LENGTHS.indexOf(selLen);
        const lo = i === 0 ? 0 : LENGTHS[i - 1];
        return (p.lengths || []).some(l => i === 0 ? l <= selLen : l > lo && l <= selLen);
      })();
      const sMatch = !activeTags.length || activeTags.every(t => (p.tags || []).includes(t));
      const aMatch = filterAngled === false ||
        (filterAngled === 'angled' ? (p.angled === true || p.angled === 'true') :
         filterAngled === 'straight' ? (!p.angled || p.angled === 'false') : true);
      const adMatch = !filterAdapter ||
        (filterAdapter === 'adapter' ? (p.tags || []).includes('cc-type-adapter') :
         filterAdapter === 'cable' ? !(p.tags || []).includes('cc-type-adapter') : true);
      const cMatch = !selA && !selB ? true :
        selA && selB ? ((p.connector_a === selA && p.connector_b === selB) || (p.connector_a === selB && p.connector_b === selA)) :
        selA ? (p.connector_a === selA || p.connector_b === selA) :
        (p.connector_a === selB || p.connector_b === selB);
      return cMatch && lMatch && sMatch && aMatch && adMatch;
    });

    const nameA = selA ? con(selA).label : null;
    const nameB = selB ? con(selB).label : null;
    const desc = [nameA, nameB].filter(Boolean).join(' ↔ ') || 'alle Kabel';
    const lenStr = selLen ? ` · ${lenChipLabel(selLen, LENGTHS.indexOf(selLen))}` : '';
    const specCnt = Object.keys(specSelections).length + (filterAngled !== false ? 1 : 0);
    bar.innerHTML = `<strong>${filtered.length}</strong> Ergebnis${filtered.length !== 1 ? 'se' : ''} für <strong>${desc}</strong>${lenStr}${specCnt ? ` · ${specCnt} Filter` : ''}`;

    if (!filtered.length) {
      grid.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:3rem 1rem;color:rgba(var(--color-foreground),0.5);font-size:1.4rem;">Keine Kabel für diese Kombination gefunden.<br>Versuche andere Filter.</div>`;
      return;
    }

    grid.innerHTML = filtered.map(p => {
      const imgHtml = p.image
        ? `<img src="${p.image}" alt="${p.title}" loading="lazy">`
        : `<svg width="80" height="30" viewBox="0 0 80 30" fill="none"><rect x="1" y="9" width="14" height="10" rx="2" stroke="rgba(var(--color-foreground),0.2)" stroke-width="1.2"/><line x1="15" y1="14" x2="65" y2="14" stroke="rgba(var(--color-foreground),0.2)" stroke-width="2.5" stroke-linecap="round"/><rect x="65" y="9" width="14" height="10" rx="2" stroke="rgba(var(--color-foreground),0.2)" stroke-width="1.2"/></svg>`;
      return `<a href="${p.url}" class="cc-card">
        <div class="cc-card__img">${imgHtml}</div>
        <div class="cc-card__name">${p.title}</div>
        <div class="cc-card__specs">${[nameA||p.connector_a, nameB||p.connector_b].filter(Boolean).join(' → ')} · ${(p.lengths||[]).map(fmtLen).join(', ')}</div>
        ${p.badge ? `<span class="cc-card__badge">${p.badge}</span>` : ''}
        <div class="cc-card__footer">
          <div class="cc-card__price">${p.price_html}</div>
          ${p.rating ? `<div class="cc-card__rating">★ ${p.rating}</div>` : ''}
        </div>
        <button class="cc-card__btn" onclick="ccAddToCart(event,${p.variant_id})" type="button">${p.available !== false ? 'In den Warenkorb' : 'Ausverkauft'}</button>
      </a>`;
    }).join('');
  }

  window.ccAddToCart = function (e, variantId) {
    e.preventDefault(); e.stopPropagation();
    if (!variantId) return;
    const url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    fetch(url, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: variantId, quantity: 1}) })
      .then(r => r.json())
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        fetch('/cart.js').then(r => r.json()).then(cart => {
          document.querySelectorAll('.cart-count-bubble').forEach(el => {
            el.querySelector('span:first-child').textContent = cart.item_count;
            el.classList.toggle('hidden', cart.item_count === 0);
          });
        });
      })
      .catch(err => console.warn('Warenkorb-Fehler:', err));
  };

  function updateAll() {
    renderLengths(); updateEmptyState(); updateSteps(); renderSpecs(); renderResults();
  }

  // ── Produkte via JSON API laden ────────────────────────────────
  function mapProduct(p) {
    const meta = p.metafields || {};
    // Metafelder aus Varianten-Tags lesen falls verfügbar
    const getM = key => {
      if (p['metafields_' + key]) return p['metafields_' + key];
      return '';
    };
    return {
      id:         p.id,
      title:      p.title,
      url:        '/products/' + p.handle,
      price_html: '€' + (p.variants[0].price),
      available:  p.variants.some(v => v.available),
      variant_id: p.variants[0].id,
      image:      p.images.length ? p.images[0].src : null,
      connector_a: p.connector_a || '',
      connector_b: p.connector_b || '',
      badge:      p.badge || '',
      rating:     p.rating || '',
      angled:     p.angled || 'false',
      lengths:    p.lengths ? p.lengths.split(',').map(Number).filter(Boolean) : [],
      tags:       p.tags_array || [],
    };
  }

  function ccTagVal(tags, prefix) {
    const t = (tags || []).find(t => t.startsWith(prefix));
    return t ? t.slice(prefix.length) : '';
  }

  function ccTagLengths(tags) {
    return (tags || [])
      .filter(t => t.startsWith('cc-l-'))
      .map(t => parseFloat(t.slice(5)))
      .filter(Boolean);
  }

  async function loadAllProducts() {
    const handle = window.CC_COLLECTION || 'kabel';
    const base = `/collections/${handle}/products.json?limit=250`;
    let page = 1;
    let all = [];
    let hasMore = true;

    // Ladehinweis
    const bar = $('cc-results-bar');
    if (bar) { bar.style.display = 'block'; bar.innerHTML = 'Produkte werden geladen…'; }

    while (hasMore) {
      try {
        const r = await fetch(`${base}&page=${page}`);
        const data = await r.json();
        const products = data.products || [];
        if (products.length === 0) {
          hasMore = false;
        } else {
          all = all.concat(products);
          page++;
          if (products.length < 250) hasMore = false;
        }
      } catch(e) {
        console.warn('Ladefehler:', e);
        hasMore = false;
      }
    }

    // Metafelder aus window.CABLE_PRODUCTS übernehmen falls vorhanden
    const metaMap = {};
    (window.CABLE_PRODUCTS || []).forEach(p => { metaMap[p.id] = p; });

    window.CABLE_PRODUCTS = all.map(p => {
      const existing = metaMap[p.id] || {};
      // Liquid-Metafelder haben immer Vorrang über API-Daten
      return {
        id:         p.id,
        title:      p.title,
        url:        '/products/' + p.handle,
        price_html: existing.price_html || ('€' + parseFloat(p.variants[0].price).toFixed(2).replace('.', ',')),
        available:  p.variants.some(v => v.available),
        variant_id: existing.variant_id || p.variants[0].id,
        image:      existing.image || (p.images.length ? p.images[0].src : null),
        connector_a: existing.connector_a || ccTagVal(p.tags, 'cc-a-') || '',
        connector_b: existing.connector_b || ccTagVal(p.tags, 'cc-b-') || '',
        badge:      existing.badge || '',
        rating:     existing.rating || '',
        angled:     existing.angled || (p.tags.includes('cc-w-true') ? 'true' : 'false'),
        lengths:    existing.lengths && existing.lengths.length ? existing.lengths : ccTagLengths(p.tags),
        tags:       existing.tags && existing.tags.length ? existing.tags : [],
      };
    });

    if (bar) bar.innerHTML = '';
    updateAll();
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Erst mit Liquid-Daten rendern, dann API-Daten nachladen
    updateAll();
    loadAllProducts();
  });
})();
